import { shallowEqual } from 'hooks/reduxHooks'
import { CreateSelectorOptions } from 'reselect'

export const reselectShallowEqual: CreateSelectorOptions = {
  memoizeOptions: {
    resultEqualityCheck: shallowEqual,
  },
}
